<template>
    <div class="editor__text text">
        <div class="text__topbar" style="max-width: 700px; padding-left: 20px;">
            <button
                type="button"
                class="button button--gray"
                style="max-width: 300px;"
                @click="back"
            >
                ‹ {{ $t('export.repair.backToBookEditing') }}
            </button>
        </div>
        <div class="text__topbar" style="max-width: 700px; padding-left: 20px;">
            <NotesBuild :book-id="book.id" build-type="notes" />
        </div>
        <div class="text__inner">
            <div
                v-if="notes && notes.length"
                class="text__container"
                style="width: 100%; max-width: 700px;"
                :class="{ 'text__container--rtl': isRtl }"
            >
                <NotesListItem
                    v-for="note in notes"
                    :key="note.id"
                    :note="note"
                    :is-active="selected && selected.note === note.id"
                    @selected="select"
                    @saved="saved"
                    @added="added"
                    @deleted="deleted"
                />
            </div>
            <div v-else v-t="$t('notes.list.empty')" />
        </div>
        <div v-if="hasNext" class="text__pagination">
            <button
                type="button"
                class="button text__button text-pagination__next"
                @click="loadNext"
            >
                {{ $t('misc.loadmore') }}
            </button>
        </div>
    </div>
</template>

<script>
import NotesListItem from '../NotesListItem/NotesListItem';
import NotesBuild from '../NotesBuild/NotesBuild';

import { mapState } from 'vuex';
import { isRtlLanguage } from '@speechki-frontend/core/editor/utils';

export default {
    name: 'NotesList',
    components: {
        NotesListItem,
        NotesBuild
    },
    props: {
        notes: {
            type: Array,
            default: () => []
        },

        hasNext: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            filter: null
        };
    },
    computed: {
        ...mapState({
            book: state => state.book.book
        }),
        isRtl() {
            return isRtlLanguage(this.book.book_language);
        }
    },
    watch: {
        filter() {
            this.$emit('filter', this.filter);
        }
    },
    methods: {
        back() {
            this.$emit('close');
        },
        select(event) {
            this.$emit('selected', event);
        },
        saved(event) {
            this.$emit('saved', event);
        },
        added(note) {
            this.$emit('added', note);
        },
        deleted(note) {
            this.$emit('deleted', note);
        },
        loadNext() {
            this.$emit('loadNext');
        }
    }
};
</script>
